import { render } from "./Icons.vue?vue&type=template&id=e4062a0c&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=e4062a0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4062a0c"

export default script